var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "LessonEntityDetails__Component" }, [
    _c(
      "div",
      { staticClass: "Accident__Entity__Details__BaseDetails__Stage" },
      [
        _c("span", { staticClass: "ltr" }, [_vm._v("טווח ציונים תקין:")]),
        _c(
          "span",
          {
            staticClass:
              "Accident__Entity__Details__BaseDetails__Stage__Value value has-text-weight-bold",
          },
          [_vm._v(_vm._s(_vm.model.madadTakinEditor))]
        ),
      ]
    ),
    _c(
      "div",
      { staticClass: "Accident__Entity__Details__BaseDetails__Stage" },
      [
        _c("span", { staticClass: "ltr" }, [_vm._v("ציון:")]),
        _c(
          "span",
          {
            staticClass:
              "Accident__Entity__Details__BaseDetails__Stage__Value value has-text-weight-bold",
          },
          [_vm._v(_vm._s(_vm.model.grade))]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }